import { api } from './api';
import { Perola } from '../types/perolas';

export async function enviarPerola(
  link_print: string,
  descricao: string
): Promise<Perola> {
  const response = await api.post('/perolas', { link_print, descricao });
  return response.data;
}

export async function listarPerolas(): Promise<Perola[]> {
  const response = await api.get('/perolas');
  return response.data;
}
